// Inline SVG sprite do DOM (kvůli currentColor — cross-document <use> ho nepřenáší).
//
// Ikonový sprite `sprite.svg` jde DO BUNDLU (esbuild text loader, build.mjs):
// hlavička, karta i patička si z něj berou ikony hned při bootu a čekání na síť
// by rozsypalo první vykreslení.
//
// Barevná loga `logos.svg` (40 kB, ~22 kB br) do bundlu NEJDOU (#313, F2
// rychlosti): jsou jen v patičce, v pokladně a v modalu doručení — nikde nad
// ohybem —, takže v bundlu stála čtvrtina jeho bajtů na kritické cestě KAŽDÉ
// stránky. Tahají se ze stejného adresáře na CDN, odkud přišel bundle, a
// standardně až po `load`.
// ⚠️ `<use href="https://cdn…#bs-logo-ppl">` prohlížeč cross-origin nepovolí →
// fetch + inline injektáž, ne externí odkaz.
// ⚠️ Asynchronní dorazení NEDĚLÁ CLS: vnější `<svg>` staví `logo()` s `viewBox`
// z `LOGO_RATIO`, takže box drží i s prázdným `<use>` (sonda 2026-09-12:
// 137,09 × 20 px před dotažením i po něm, `ops/sweeps/2026-09-12-logos-sprite-cdn/`).
import spriteMarkup from '../../img/sprite.svg';
import { DEV_ASSETS } from './instanceUrl.js';

// Vloží <svg> sprite na začátek <body>. Idempotentní dle guardId (id symbolu uvnitř spritu).
// source = markup (esbuild) NEBO URL (logos.svg z CDN, Bender webpack) — obojí zvládneme.
// Vrací promise, která je splněná, až sprite v DOM je (nebo to vzdala).
export function injectSvgSprite(source, guardId) {
  if (document.getElementById(guardId)) return Promise.resolve();
  const place = function (markup) {
    if (document.getElementById(guardId)) return; // mezitím injektováno jinde
    const tpl = document.createElement('template');
    tpl.innerHTML = (markup || '').trim();
    const svg = tpl.content.firstElementChild;
    if (svg) document.body.insertBefore(svg, document.body.firstChild);
  };
  if (typeof source === 'string' && source.indexOf('<svg') !== -1) {
    place(source); // esbuild (produkce): markup přímo
    return Promise.resolve();
  }
  if (typeof source === 'string' && source) {
    return fetch(source)
      .then(function (r) { return r.text(); })
      .then(place)
      .catch(function () {});
  }
  return Promise.resolve();
}

// URL `logos.svg` vedle nasazeného bundlu. Bere se ze `<script src>`, protože
// ten jediný nese správnou CDN cestu I instanci (dev `usr/797093.myshoptet.com`,
// ostrá `usr/www.jipos.cz` — přepisuje ji html-kody.mjs) a hlavně `?v=` shodné
// s bundlem: CDN drží assety s `max-age` rok, bez cache-bustu by nový sprite
// nikdy nedorazil.
// Relativní `src` fixtur (`../dist/build.min.js`) se resolvuje na `file://`,
// odkud fetch nejde — tam i v Benderu (ten má vlastní webpack bundle, náš
// `<script>` na stránce není) se spadne na dev instanci; CDN má
// `Access-Control-Allow-Origin: *`, takže fetch projde i z opaque originu.
function logosUrl() {
  const el = document.querySelector('script[src*="build.min.js"]');
  const src = el ? el.src : '';
  if (/^https?:/i.test(src)) return src.replace('build.min.js', 'logos.svg');
  const ver = typeof __BS_BUILD__ === 'string' ? __BS_BUILD__ : 'dev';
  return DEV_ASSETS + 'logos.svg?v=' + ver;
}

let logosPromise = null;

/**
 * Dotáhne sprite log HNED. Idempotentní — volá ho `scheduleLogos()` po `load`
 * i místa, která loga potřebují dřív (pokladna, modal doručení).
 */
export function ensureLogos() {
  if (!logosPromise) logosPromise = injectSvgSprite(logosUrl(), 'bs-logo-ppl');
  return logosPromise;
}

let logosScheduled = false;

/**
 * Odloží dotažení za `load` + idle (týž vzor jako loader Clarity v hlavičce):
 * loga jsou pod ohybem, v prvním okně by 40 kB šlo proti smyslu změny.
 * Strop 5 s kryje `load` zaseknutý na médiu nebo třetí straně.
 */
export function scheduleLogos() {
  if (logosScheduled) return;
  logosScheduled = true;
  if (document.readyState === 'complete') {
    ensureLogos();
    return;
  }
  const go = function () { ensureLogos(); };
  addEventListener('load', function () {
    if (window.requestIdleCallback) window.requestIdleCallback(go, { timeout: 2000 });
    else setTimeout(go, 1);
  });
  setTimeout(go, 5000);
}

export function injectSprite() {
  injectSvgSprite(spriteMarkup, 'bs-i-cart'); // guard = známý symbol hlavního spritu
}
